import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { memo } from 'react';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["children"];
var TableBody = function TableBody(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  return /*#__PURE__*/React.createElement("tbody", _extends({}, rest, {
    className: className,
    style: style
  }), children);
};
var TableBody$1 = /*#__PURE__*/memo(TableBody);

export default TableBody$1;
